export default __webpack_public_path__ + "static/media/retalhar@2x.6307a152.png";